var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNopic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "13.3173mm",
    height: "13.3173mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 256 256",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n   .fil1 {fill:none}\r\n   .fil0 {fill:#CCCCCC}\r\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M197 59c38,38 38,100 0,138 -38,38 -100,38 -138,0 -38,-38 -38,-100 0,-138 38,-38 100,-38 138,0zm-10 28l-100 100c28,20 67,17 92,-8 25,-25 28,-64 8,-92zm-118 83l101 -101c-29,-20 -68,-17 -93,8 -25,25 -28,64 -8,93z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    width: 256,
    height: 256
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNopic);
export default __webpack_public_path__ + "static/media/nopic.66ee4df54adc6f88e8f8000b3a10990d.svg";
export { ForwardRef as ReactComponent };